import { render } from "./page-loader.vue?vue&type=template&id=5ffd68cf"
import script from "./page-loader.vue?vue&type=script&lang=js"
export * from "./page-loader.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__